.small-ticket-search .ticket-search {
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e5e5;
  max-height: 40px;
}
.small-ticket-search .ticket-search label {
  margin-bottom: 0;
}
.small-ticket-search .ticket-search .form-control {
  width: 160px;
}
@media screen and (max-width: 500px) {
  .small-ticket-search .ticket-search .form-control {
    width: 25vw;
    max-width: 100px;
  }
}
.small-ticket-search .ticket-search .search-btn-container {
  position: relative;
  width: 50px;
}
.small-ticket-search .alert-danger {
  max-width: 400px;
}
@media screen and (max-width: 1024px) {
  .small-ticket-search .ticket-search {
    margin-bottom: 10px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvb3JnYW5pc21zL3NlbGVjdHRpY2tldHMiLCJzb3VyY2VzIjpbInNtYWxsLXRpY2tldC1zZWFyY2guc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDSTtFQUNJO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0k7O0FBR0o7RUFDSTs7QUFFQTtFQUhKO0lBSVE7SUFDQTs7O0FBSVI7RUFDSTtFQUNBOztBQUlSO0VBQ0k7O0FBR0o7RUFDSTtJQUNJIiwic291cmNlc0NvbnRlbnQiOlsiLnNtYWxsLXRpY2tldC1zZWFyY2gge1xuICAgIC50aWNrZXQtc2VhcmNoIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgIGdhcDogMTBweDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgcGFkZGluZy1ib3R0b206IDEwcHg7XG4gICAgICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZTVlNWU1O1xuICAgICAgICBtYXgtaGVpZ2h0OiA0MHB4O1xuICAgIFxuICAgICAgICBsYWJlbCB7XG4gICAgICAgICAgICBtYXJnaW4tYm90dG9tOiAwO1xuICAgICAgICB9XG5cbiAgICAgICAgLmZvcm0tY29udHJvbCB7XG4gICAgICAgICAgICB3aWR0aDogMTYwcHg7XG5cbiAgICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDUwMHB4KSB7XG4gICAgICAgICAgICAgICAgd2lkdGg6IDI1dnc7XG4gICAgICAgICAgICAgICAgbWF4LXdpZHRoOiAxMDBweDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfVxuXG4gICAgICAgIC5zZWFyY2gtYnRuLWNvbnRhaW5lciB7XG4gICAgICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgICAgICB3aWR0aDogNTBweDtcbiAgICAgICAgfVxuICAgIH1cblxuICAgIC5hbGVydC1kYW5nZXIge1xuICAgICAgICBtYXgtd2lkdGg6IDQwMHB4O1xuICAgIH1cblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDEwMjRweCkge1xuICAgICAgICAudGlja2V0LXNlYXJjaCB7XG4gICAgICAgICAgICBtYXJnaW4tYm90dG9tOiAxMHB4O1xuICAgICAgICB9XG4gICAgfVxufSJdfQ== */